import { useTranslation } from 'react-i18next';
import { DayPickerRange } from '@anytag/shared-molecules';
import { SelectedRangeOption } from '@anytag/shared-types';
import { BasicAccountAnalyticsPayload } from '@anytag/graphql';
import { cn, getToday, getTwoYearsAgo } from '@anytag/shared-utils';
import { AnalyticsSelectedAccountInfo } from '../../types';
import { useAnalyticsProfileSearch } from '../../hooks';
import { AnalyticsAccountsSelector } from './AnalyticsAccountsSelector';
import { DownloadAnalyticsAccountsButton } from './DownloadAnalyticsAccountsButton';

interface AnalyticsHeaderActionsProps {
  className?: string;
  brandAccount: BasicAccountAnalyticsPayload;
  analyticsAccount: AnalyticsSelectedAccountInfo;
}

export const AnalyticsHeaderActions = ({ className, brandAccount, analyticsAccount }: AnalyticsHeaderActionsProps) => {
  const { t } = useTranslation();
  const { filter, setFilter } = useAnalyticsProfileSearch();
  const isAllTime = !filter?.startDate && !filter?.endDate;

  return (
    <div className={cn('flex gap-2', className)}>
      <AnalyticsAccountsSelector analyticsAccount={analyticsAccount} brandAccount={brandAccount} />
      <DayPickerRange
        align="end"
        period={filter}
        clearable={false}
        withinPortal={false}
        handleChangePeriod={setFilter}
        disabledRange={{ after: new Date() }}
        initialPeriod={{ startDate: getTwoYearsAgo(), endDate: getToday() }} // for All_Time
        customInputTextNode={isAllTime ? <p className="icon-color-tertiary">{t('Select post date')}</p> : undefined}
        rangeList={[
          SelectedRangeOption.TODAY,
          SelectedRangeOption.TODAY_TO_MONTH_AGO,
          SelectedRangeOption.THIS_MONTH,
          SelectedRangeOption.LAST_MONTH,
          SelectedRangeOption.CUSTOM
        ]}
      />
      <DownloadAnalyticsAccountsButton filter={filter} analyticsAccount={analyticsAccount} />
    </div>
  );
};
